<template>
  <div class="drop-down-list-wrapper">
    <div :class="[customClass]">
      <div class="input-group-prepend">
        <span class="input-group-text border-0 grab" style="background-color:white;">
          <i :class="iconPreAppend"></i>
        </span>
      </div>
      <input
        class="form-control rounded"
        v-model="searchText"
        type="search"
        :placeholder="placeholder"
        @change="onSearchInputChange($event)"
      >
      <div class="input-group-append">
        <span class="input-group-text border-0" style="background-color:white;">
          <i :class="iconAppend" @click="$emit('delete')"></i>
        </span>
      </div>
    </div>
    <ul class="drop-down-list" v-if="showResults">
      <li
        class="drop-down-list-item pointer"
        v-for="result in results"
        :key="result.id"
        @click="setValue($event, result)"
      >{{result.name}}</li>
    </ul>
  </div>
</template>
<script>

export default {
  data () {
    return {
      selected: false,
      searchText: '',
      showResults: false
    }
  },
  props: {
    search: {
      type: Function
    },
    results: {
      type: Array
    },
    placeholder: {
      type: String
    },
    value: { default: '' },
    customClass: { type: String, default: 'input-group' },
    iconPreAppend: { type: String },
    iconAppend: { type: String }
  },
  methods: {
    onSearchInputChange ($event) {
      this.showResults = true
      this.search($event)
    },
    setValue ($event, result) {
      this.showResults = false
      this.searchText = ''
      this.$emit('input', result)
      this.$emit('setvalue', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.drop-down-list-wrapper {
  position: relative;
  .form-control {
    &:focus {
      box-shadow: none !important;
    }
    &:focus::-webkit-input-placeholder {
      color: transparent;
    }
  }
  .drop-down-list {
    list-style-type: none;
    padding: 0px;
    margin: 5px 0px 0px 0px;
    z-index: 999;
    position: absolute;
    background-color: $white;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    li {
      width: 100%;
      padding: 0.15rem 0.75rem;
      border-left: solid 0.5px $gray-300;
      border-right: solid 0.5px $gray-300;
      outline: none;
      &:hover {
        background-color: $gray-300;
      }
      &:last-child {
        border-bottom: solid 0.5px $gray-300;
        border-radius: 0rem 0rem 0.25rem 0.25rem;
      }
      &:first-child {
        border-top: solid 0.5px $gray-300;
        border-radius: 0.25rem 0.25rem 0rem 0rem;
      }
    }
  }
}
</style>
